export interface IFeatureFlagsResponse {
  drHortonIntegrationEnabled: boolean;
  advancedWorkOrdersEnabled: boolean;
  miDispatchEnabled: boolean;
  miInspectionsEnabled: boolean;
  miSchedulingEnabled: boolean;
  miAccountingEnabled: boolean;
  miEstimatingEnabled: boolean;
  miDayEnabled: boolean;
  miBuildMobileEnabled: boolean;
  miAssignmentEnabled: boolean;
}

export enum FeatureFlagKey {
  DrHortonIntegrationEnabled = "drHortonIntegrationEnabled",
  AdvancedWorkOrdersEnabled = "advancedWorkOrdersEnabled",
  MiDispatchEnabled = "miDispatchEnabled",
  MiInspectionsEnabled = "miInspectionsEnabled",
  MiSchedulingEnabled = "miSchedulingEnabled",
  MiAccountingEnabled = "miAccountingEnabled",
  MiEstimatingEnabled = "miEstimatingEnabled",
  MiDayEnabled = "miDayEnabled",
  MiBuildMobileEnabled = "miBuildMobileEnabled",
  MiAssignmentEnabled = "miAssignmentEnabled",
}
